export default __webpack_public_path__ + "88d3d0ec2ead353401421b1642a0f79b.svg";